/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
const fonts = {
  headingLarge: `
    font-size: 28px;
    font-weight: lighter;
    color: #16325C;
  `,
  headingMedium: `
    font-size: 20px;
    color: #16325C;
  `,
  headingSmall: `
    font-size: 16px;
    color: #16325C;
  `,
  headingLabelCaps: `
    font-size: 12px;
    font-weight: normal;
    color: #54698D;
    text-transform: uppercase;
    letter-spacing: 0.875px;
  `,
  headingLabel: `
    font-size: 12px;
    font-weight: normal;
    color: #54698D;
  `,
  base: `
    font-size: 14px;
    font-weight: normal;
    color: #54698D;
  `,
  baseSmall: `
    font-size: 12px;
    color: #54698D;
  `,
  linkBase: `
    font-size: 12px;
    color: #1589EE;
  `,
  baseResults: `
    font-size: 13px;
    font-weight: lighter;
    color: #16325C;
  `,
  linkResults: `
    font-size: 13px;
    color: #1589EE;
  `,
  footerLabel:`
    color: #a8b7c7;
    font-size: 12px;
    letter-spacing: 0px;
    line-height: 1.7;
  `,
};

export default fonts;
